import React, { useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import axios from "axios";

import { useTranslation } from 'react-i18next';
import { normalizeKey } from '../i18n';




const backendUrl = process.env.REACT_APP_BACKEND_URL;

const ContactForm = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const { t } = useTranslation();
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!executeRecaptcha) {
      console.error("Recaptcha not yet ready");
      return;
    }

    const token = await executeRecaptcha("contact_form");
      
   //   console.log("token", token);

    // Send token and form data to backend
    const response = await axios.post(`${backendUrl}/api/contact-messages`, {
      ...formData,
      captchaToken: token,
    });
alert("Thank you for contacting us. we will get back to you within 14 days!! ");
   setFormData({ name: "", email: "", message: "" });
  };

  return (
    <div
      style={{
        maxWidth: "900px",
        margin: "40px auto",
        padding: "10px",
        borderRadius: "10px",
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
        backgroundColor: "#fff",
      }}
        
    >
      <h2 style={{ textAlign: "center", marginBottom: "20px" }}>{t('contact_us' , 'Contact Us')}</h2>

      <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
        <input
          type="text"
          placeholder="Your Name"
          value={formData.name}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
          style={{
            padding: "12px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "16px",
          }}
          required
        />

        <input
          type="email"
          placeholder="Your Email"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          style={{
            padding: "12px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "16px",
          }}
          required
        />

        <textarea
          placeholder="Your Message"
          value={formData.message}
          onChange={(e) => setFormData({ ...formData, message: e.target.value })}
          rows="5"
          style={{
            padding: "12px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "16px",
            resize: "vertical",
          }}
          required
        />

        <button
          type="submit"
          style={{
            backgroundColor: "#1976d2",
            color: "#fff",
            padding: "12px",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "16px",
            fontWeight: "bold",
            transition: "background-color 0.3s ease",
          }}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#125a9c")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#1976d2")}
        >
        {t('send_message' , 'Send Message')}  
        </button>
      </form>
    </div>
  );
};

export default ContactForm;
